export default __webpack_public_path__ + "ffc593c286ae95c581645cb2ac55f31a.png";